import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'

export const Container = styled.div.attrs(() => ({
  className: 'cabin-passengers'
}))`
  width: 100%;
  outline: none;
  cursor: pointer;
  ${({ fullWidth }) => !fullWidth && `width: 250px;`}
  ${mediaQueries.mobile`
    padding-bottom: ${({ contentVisibility }) => contentVisibility && '20rem'};
  `};
`

const getBorderColor = ({ focus, error, flatStyle, theme }) => {
  if (focus) {
    return theme.colors.blue
  }

  if (error) {
    return theme.colors.red
  }

  if (flatStyle) {
    return theme.colors.veryLightPink
  }

  return theme.colors.transparent
}

export const Header = styled.button`
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${props => getBorderColor(props)};
  ${({ flatStyle, theme }) =>
    !flatStyle &&
    `box-shadow: 0 2px 10px 0 ${theme.shadow.black26}, 0 2px 5px 0 ${theme.shadow.black06};`};

  ${({ focus, flatStyle, theme }) =>
    focus && flatStyle && `box-shadow: 0 2px 4px 0  ${theme.shadow.black09};`} display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 13px 10px 12px;
  border-radius: 3px;
  width: 100%;

  &:focus-visible {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }
`

export const HeaderText = styled.div`
  width: 100%;
  overflow: hidden;
  display: inline-flex;
  color: ${({ theme }) => theme.colors.blueDark};
  white-space: nowrap;
`

export const HeaderPassenger = styled.span.attrs(props => ({
  className: 'label-passenger',
  value: `${props.value}`
}))`
  font-family: ${({ theme }) => theme.fonts.semiBold};
  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.red};
    `};
`

export const HeaderClass = styled.span.attrs(props => ({
  className: 'label-cabin',
  value: `${props.value}`
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  text-overflow: ellipsis;
  overflow: hidden;
`

export const ContentContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border: solid 1px ${({ theme }) => theme.colors.blue};
  box-shadow: 0 2px 4px 0 ${({ theme }) => theme.shadow.black09};
  border-radius: 3px;
  margin-top: 5px;
  display: none;
  z-index: 1;
  position: absolute;
  padding: 15px 25px;
  width: 285px;

  ${({ isVisible }) =>
    isVisible &&
    css`
      display: block;
    `};

  ${mediaQueries.mobile`
    width: calc(100% - 40px);
  `};
`

export const InputsNumberContainer = styled.div`
  margin-top: 10px;
`

export const InputNumberTitle = styled.label`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.blueDark};
`

export const InputNumberAge = styled.label`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 11px;
  font-style: italic;
  color: ${({ theme }) => theme.colors.doveGray};
  margin: 0 0 0 0.625em;
`

export const ErrorContainer = styled.div.attrs(() => ({
  className: 'error-cabin-passengers'
}))`
  margin-top: 10px;
`

export const OutsideErrorContainer = styled.div.attrs(() => ({
  className: 'error-cabin-passengers'
}))`
  position: absolute;
  width: 15em;
  margin: 0.7em 0 0.3em;

  ${mediaQueries.tablet`
    position: relative;
    width: 100%;
    margin-top: 14px;
  `};
`

export const DisclaimerWrapper = styled.div`
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.italic};

  font-size: 14px;
  display: flex;
`

export const DisclaimerText = styled.span`
  margin-left: 10px;
  margin-top: 15px;
`
